<template>
  <a :href="document.url" target="_blank" class="document">
    <div class="icon-container d-flex align-items-center justify-content-center">
      <AttachmentIcon/>
    </div>
    <div class="title" :title="document.originalFilename ?? 'Bestandsnaam'">
      <span>{{ document.originalFilename ?? "Bestandsnaam" }}</span>
    </div>
  </a>
</template>

<script>
import AttachmentIcon from "@/assets/image/icons/icon-attachment.svg?inline";

export default {
  name: "Document",
  components: { AttachmentIcon },
  props: {
    document: Object
  }
}
</script>

<style lang="scss" scoped>
.document {
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  display: flex;
  color: black;

  &:hover, &:visited {
    color: black;
  }

  .icon-container {
    font-size: 30px;
    overflow: visible;

    height: 100%;
    aspect-ratio: 1 / 1;

    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;

    background-color: $activity-orange;
    color: $font-light;

    svg
    {
      fill: $font-light;
    }
  }

  .title
  {
    padding: 10px;
    flex: 1 1;

    display: flex;
    flex-direction: column;

    justify-content: center;
    align-content: center;

    font-size: 0.875rem;
    font-weight: 500;

    min-width: 0;

    span
    {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>